/**
 * @returns x as an array or throws if x is not an array
 */
export function assertArray<K, T extends unknown | Array<K>>(x: T): Array<K> {
    if (Array.isArray(x)) {
        return x;
    }
    throw new Error('Expected value to be an array but was ' + typeof x);
}
